export const LEGALMASTER_LOADING = "LEGALMASTER_LOADING";
export const LEGALMASTER_RESET = "LEGALMASTER_RESET";
export const GET_LEGALMASTER = "GET_LEGALMASTER";
export const GET_LEGALMASTER_SUCCESS = "GET_LEGALMASTER_SUCCESS";
export const GET_LEGALMASTER_FAIL = "GET_LEGALMASTER_FAIL";
export const DELETE_LEGALMASTER = "DELETE_LEGALMASTER"
export const DELETE_LEGALMASTER_SUCCESS = "DELETE_LEGALMASTER_SUCCESS"
export const DELETE_LEGALMASTER_FAIL = "DELETE_LEGALMASTER_FAIL"
export const UPDATE_LEGALMASTER = "UPDATE_LEGALMASTER"
export const UPDATE_LEGALMASTER_SUCCESS = "UPDATE_LEGALMASTER_SUCCESS"
export const UPDATE_LEGALMASTER_FAIL = "UPDATE_LEGALMASTER_FAIL"
export const ADD_NEW_LEGALMASTER = "ADD_NEW_LEGALMASTER"
export const ADD_LEGALMASTER_SUCCESS = "ADD_LEGALMASTER_SUCCESS"
export const ADD_LEGALMASTER_FAIL = "ADD_LEGALMASTER_FAIL"